import { React, useContext, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import UserPanelTitle from '../../Components/UserPanelTitle/UserPanelTitle'
import './Checkout.css'
import Zarinpal from '../../Assets/images/zarinpal.png'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import Swal from 'sweetalert2'
import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { toast } from 'react-toastify'
import { CartContext } from '../../Hooks/CartContext'
import { Helmet } from 'react-helmet-async'
let addressId = '';

export default function Checkout() {
    const [selectedAddress, setSelectedAddress] = useState('');
    const { cartItems } = useContext(CartContext);
    const [inputValues, setInputValues] = useState({
        owner: '',
        phoneNumber: '',
        province: '',
        city: '',
        fullAddress: '',
        postalCode: '',
    });
    const location = useLocation();
    const [UserAddress, setUserAddress] = useState([])


    useEffect(() => {
        getAddress()
    }, [])

    const getAddress = () => {
        axiosConfig.get("api/Address").then((res) => {
            setUserAddress(res.data.data)
        })
    }

    const handleChange = (e) => {
        setInputValues({
            ...inputValues,
            [e.target.name]: e.target.value,
        });
    };

    const handleInputChange = (e) => {
        setSelectedAddress(e.target.value);
        addressId = UserAddress[parseInt(e.target.value.replace('option', ''))].id
        axiosConfig.get(`api/ShoppingCart/BasketAddress/${addressId}`);
    };

    const sendAddress = () => {
        axiosConfig
            .post("api/Address", { ...inputValues, UserId: localStorage.getItem("userId"), UserName: localStorage.getItem("name") })
            .then((result) => {
                getAddress();
            })
            .catch((err) => {
                Swal.fire({
                    icon: "error",
                    title: "خطا",
                    text: "لطفا اطلاعات را درست وارد کنید",
                    confirmButtonText: "تلاش مجدد",
                });
            });

    }

    const sendData = () => {
        if (addressId == '')
            return toast.warning('لطفا آدرس را انتخاب کنید')
        axiosConfig.get('pay').then((res) => {
            window.location = res.data.data
        });
    }
    return (
        <>
            <Helmet>
                <title>صفحه پرداخت امن و سریع | سه‌نیک</title>
                <meta
                    name="description"
                    content="پرداخت آسان، سریع و امن برای دوره‌ها و محصولات آموزشی سه‌نیک. مراحل ساده پرداخت و تایید سفارش در یک تجربه مطمئن و کاربرپسند."
                />
            </Helmet>
            <div className='Checkout'>
                <Container>
                    <Row>
                        <Col lg={8}>
                            <div className='Checkout-right'>
                                <UserPanelTitle title='افزودن ادرس جدید' />
                                <div className='Checkout-right-inputes'>
                                    <Row>
                                        <Col xs={12} lg={6}>
                                            <input type="text" name="owner"
                                                value={inputValues.owner} className='Checkout-right-input' placeholder='نام و نام خانوادگی' onChange={handleChange} />
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <input type="text" name="phoneNumber"
                                                value={inputValues.phoneNumber} className='Checkout-right-input' placeholder='شماره موبایل ' onChange={handleChange} />
                                        </Col>
                                    </Row>
                                    <Row className='Checkout-right-inputes-row'>
                                        <Col xs={12} lg={6}>
                                            <input type="text" name="province"
                                                value={inputValues.province} className='Checkout-right-input' placeholder='نام استان' onChange={handleChange} />
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <input type="text" name="city"
                                                value={inputValues.city} className='Checkout-right-input' placeholder='نام شهر' onChange={handleChange} />
                                        </Col>
                                    </Row>
                                    <Row className='Checkout-right-inputes-row'>
                                        <Col xs={12} lg={6}>
                                            <input type="text" name="fullAddress"
                                                value={inputValues.fullAddress} className='Checkout-right-input' placeholder=' ثبت ادرس جدید' onChange={handleChange} />
                                        </Col>
                                        <Col xs={12} lg={6}>
                                            <input type="text" name="postalCode"
                                                value={inputValues.postalCode} className='Checkout-right-input' placeholder='کد پستی' onChange={handleChange} />
                                        </Col>
                                    </Row>
                                    <Row className='Checkout-right-inputes-row'>
                                        <Col xs={12} lg={12} className='checkout-btn'>
                                            <button onClick={sendAddress}>ثبت ادرس جدید</button>

                                        </Col>
                                    </Row>
                                    {
                                        UserAddress.length ? (
                                            <Row className='Checkout-right-inputes-row'>
                                                <UserPanelTitle title='انتخاب ادرس' />
                                                {
                                                    UserAddress.map((address, index) => (
                                                        <Col xs={12}>
                                                            <div className='user-adrress-check'>
                                                                <input type="checkbox" id={`option${index}`}
                                                                    value={`option${index}`}
                                                                    checked={selectedAddress === `option${index}`}
                                                                    onChange={handleInputChange} placeholder='کد پستی' />
                                                                <label for="">{address.fullAddress}</label>
                                                            </div>
                                                        </Col>
                                                    ))
                                                }
                                            </Row>
                                        ) : (
                                            null
                                        )
                                    }


                                </div>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className='Checkout-left'>
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <th scope="row">تعداد محصول</th>
                                            <td>
                                                {cartItems} عدد
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">جمع کل</th>
                                            <td>
                                                {location.state.price.toLocaleString("fa-IR")}
                                            </td>
                                        </tr>
                                        {/* <tr>
                                            <th>جمع با تخفیف</th>
                                            <td className="total-price">
                                                130,400
                                            </td>
                                        </tr> */}
                                    </tbody>
                                </table>
                                <div className='payment-gateway'>
                                    <input type="radio" checked={true} />
                                    <div>
                                        <h3>پرداخت امن زرین پال</h3>
                                        <img src={Zarinpal} alt="" />
                                    </div>
                                </div>
                                <h2 className='payment-gateway-desc'>پرداخت امن به وسیله کلیه کارت های عضو شتاب</h2>
                                <div className='checkout-btn'>
                                    <button onClick={sendData}>ثبت سفارش</button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div >
        </>

    )
}
